// extracted by mini-css-extract-plugin
export default {"wrapper":"TransactionsDetailsAsideHash_wrapper__JmPON","copied":"TransactionsDetailsAsideHash_copied__Os+v7","copyIcon":"TransactionsDetailsAsideHash_copyIcon__-jBBM"};